/**
 * Base UI treats a FALSY toggle value as no value at all.
 *
 * `Toggle` resolves its value as `useBaseUiId(valueProp || undefined)`, with the comment
 * "`|| undefined` handles cases, where value is falsy (i.e. "")". So an entry whose value is
 * the empty string is given a generated id instead: it never matches the group's value, so it
 * reports itself unpressed however the group is controlled, and a click on it hands the group
 * an id no caller owns.
 *
 * A caller cannot avoid this by choosing better values — the empty string is a legitimate key
 * in plenty of domains (a preflop action line for the first actor to speak, a "no filter"
 * option, an empty search facet). So the group escapes every value on its way to Base UI and
 * unescapes on the way back. Nothing else changes: our own pressed treatment, the brush
 * gesture and `data-brush-value` all keep working in the caller's own vocabulary.
 *
 * The escaped form never reaches the DOM — `Toggle` destructures `value` out of the props it
 * spreads and uses it only for group membership — so this is invisible to tests, to the
 * accessibility tree and to any oracle reading the rendered markup.
 */
const VALUE_PREFIX = 'gto-toggle:'

export const escapeToggleValue = (value: string): string => `${VALUE_PREFIX}${value}`

export const unescapeToggleValue = (value: string): string => value.slice(VALUE_PREFIX.length)
